import { motion } from "framer-motion";
import { MessageCircle, MapPin, Phone, Clock, Mail } from "lucide-react";
import { waLink, WA_DEFAULT_MSG } from "../lib/site";
import { useContent } from "../context/ContentContext";

export default function Contact() {
  const content = useContent();
  const c = content.contact;

  const details = [
    { icon: MapPin, label: "Dirección", value: c.address, testid: "contact-address" },
    { icon: Phone, label: "Teléfono / WhatsApp", value: c.phone, testid: "contact-phone" },
    { icon: Clock, label: "Horario", value: c.schedule, testid: "contact-schedule" },
    { icon: Mail, label: "Correo", value: c.email, testid: "contact-email" },
  ];

  return (
    <section id="contacto" className="py-24 lg:py-32" data-testid="contact-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
          >
            <p className="font-mono mb-4 text-xs uppercase tracking-[0.3em] text-brand">
              {c.overline}
            </p>
            <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-neutral-900 sm:text-3xl lg:text-4xl">
              {c.title}
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-neutral-500 sm:text-base">
              {c.subtitle}
            </p>
            <motion.a
              href={waLink(WA_DEFAULT_MSG, content.whatsapp_number)}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              data-testid="contact-whatsapp-button"
              className="wa-pulse mt-8 inline-flex items-center gap-3 rounded-full bg-wa px-8 py-4 text-base font-bold text-black transition-colors duration-200 hover:bg-wa-hover"
            >
              <MessageCircle size={20} strokeWidth={2.5} />
              Escribir por WhatsApp
            </motion.a>
          </motion.div>

          <div className="grid gap-4 sm:grid-cols-2">
            {details.map((d, i) => (
              <motion.div
                key={d.label}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.6 }}
                className="rounded-2xl border border-[#E8E4D9] bg-white p-5 shadow-sm"
                data-testid={d.testid}
              >
                <d.icon size={18} className="mb-3 text-brand" />
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-400">
                  {d.label}
                </p>
                <p className="mt-2 text-sm font-semibold leading-snug text-neutral-900">{d.value}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
